import { Controller } from "@hotwired/stimulus"

const KEY = "pay-sidebar"
const WIDTH_KEY = "pay-sidebar-width"
const MIN = 224
const MAX = 420
const SNAP = 180
const CLICK = 3

export default class extends Controller {
  connect() {
    this.onKey = this.onKey.bind(this)
    this.onMove = this.onMove.bind(this)
    this.onUp = this.onUp.bind(this)

    document.addEventListener("keydown", this.onKey)

    if (this.stored() === "closed") this.set(false)

    const width = Number(this.read(WIDTH_KEY))

    if (width) this.width(width)
  }

  startResize(event) {
    if (event.button !== 0) return

    event.preventDefault()

    this.startX = event.clientX
    this.moved = false
    this.startWidth = this.element.querySelector("aside").getBoundingClientRect().width

    document.addEventListener("pointermove", this.onMove)
    document.addEventListener("pointerup", this.onUp, { once: true })
    document.body.classList.add("cursor-col-resize", "select-none")
  }

  onMove(event) {
    const delta = event.clientX - this.startX

    if (Math.abs(delta) < CLICK && !this.moved) return

    this.moved = true

    const wanted = this.startWidth + delta

    if (wanted < SNAP) {
      this.set(false)

      return
    }

    this.set(true)
    this.width(wanted)
  }

  onUp() {
    document.removeEventListener("pointermove", this.onMove)
    document.body.classList.remove("cursor-col-resize", "select-none")

    if (this.moved) {
      const open = this.element.dataset.sidebar !== "closed"

      if (open) this.write(WIDTH_KEY, String(Math.round(this.current)))

      this.store(open ? "open" : "closed")

      return
    }

    this.toggle()
  }

  width(value) {
    this.current = Math.min(MAX, Math.max(MIN, value))
    this.element.style.setProperty("--sidebar-width", `${this.current}px`)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
    document.removeEventListener("pointermove", this.onMove)
  }

  toggle() {
    const open = this.element.dataset.sidebar === "closed"

    this.set(open)
    this.store(open ? "open" : "closed")
  }

  set(open) {
    this.element.dataset.sidebar = open ? "open" : "closed"
  }

  onKey(event) {
    const typing = event.target.closest("input, textarea, select, [contenteditable]")

    if (event.key !== "[" || typing || event.metaKey || event.ctrlKey || event.altKey) return

    event.preventDefault()
    this.toggle()
  }

  stored() {
    return this.read(KEY)
  }

  store(state) {
    this.write(KEY, state)
  }

  read(key) {
    try {
      return localStorage.getItem(key)
    } catch (e) {
      return null
    }
  }

  write(key, value) {
    try {
      localStorage.setItem(key, value)
    } catch (e) {
      console.warn("sidebar state not saved", e)
    }
  }
}
